
// TODO: Add typescript
// const DateField: React.FC<any> = (props) => {
const DateField = (props: any) => {
  return (
    <div className="filter-fields" key={props.name}>
      <h3 className="title">{props.label}</h3>
      <input
        type="date"
        value={props.value}
        name={props.name}
        key={props.name}
        onChange={(e) => props.onChange(e)}
      />
    </div>
  );
};

export default DateField;
